module.exports = __webpack_public_path__ + "img/20190613162152487.2f50aadd.png";